<template>
  <div
    class="view view_Kinder"
    v-if="doRender"
  >
    <viewTabsTop v-if="tabs.length > 1" :tabs="tabs" />
    <!-- CONTENT -->
    <v-container
      v-if="offline"
    >
      <v-alert
        dense transition="scale-transition"
        type="error"
        class="ma-2"
        style="font-size:80%;"
      >
        <b>KEINE NETZWERKVERBINDUNG</b>
        <br>
        Die angezeigten Daten können veraltet sein.
        Bevor Änderungen vorgenommen werden, vergewissern Sie sich, dass die Daten aktuell sind.
      </v-alert>
    </v-container>
    <v-container v-else-if="syncProblem">
      <v-alert
        dense transition="scale-transition"
        type="warning"
        class="ma-2"
        style="font-size:80%;"
      >
        <b>Synchronisierung verzögert</b>
        <br>
        {{ syncProblem }} Die zuletzt geladenen Daten bleiben sichtbar.
      </v-alert>
    </v-container>
    <v-progress-linear
      indeterminate
      v-if="loading"
      absolute
    ></v-progress-linear>
    <transition
      v-if="
        currentTab.code === ''
        && tabs.filter((o) => o.erlaubt === 'x|200|000|000').length > 0
      "
      name="custom-classes-transition"
      :enter-active-class="transitionIn"
      :leave-active-class="transitionOut"
    >
      <Kinderverwaltung
        v-if="save.xtime"
        :prop_klassen="save.klassen"
        :prop_settings="save.settings"
        :prop_kinder="save.kinder"
        :prop_eltern="save.eltern"
        :offline="this.offline"
        :prop_kindUpdated="kindUpdated"
        @saveSettings="tryGetOrSaveSettings($event);"
      />
    </transition>
    <transition
      v-else-if="
        currentTab.code === '100'
        && tabs.filter((o) => o.erlaubt === 'x|200|100').length > 0
      "
      name="custom-classes-transition"
      :enter-active-class="transitionIn"
      :leave-active-class="transitionOut"
    >
      <Elternverwaltung
        :prop_eltern="save.eltern"
        :prop_kinder="save.kinder"
        :prop_klassen="save.klassen"
        :prop_kindUpdated="kindUpdated"
        :prop_query="this.currentTab.query"
        @saveSettings="tryGetOrSaveSettings($event);"
      />
    </transition>
    <transition
      v-else-if="
        currentTab.code === '200'
        && tabs.filter((o) => o.erlaubt === 'x|200|200').length > 0
      "
      name="custom-classes-transition"
      :enter-active-class="transitionIn"
      :leave-active-class="transitionOut"
    >
      <Statistik
        v-if="save.xtime"
        :prop_kinder="save.kinder"
        :prop_anwesenheiten="save.anwesenheiten"
        :prop_anwesenheitenMonate="save.anwesenheitenMonate"
        :prop_anwesenheitenDokumente="save.anwesenheitenDokumente"
        :prop_klassen="save.klassen"
        @neuAnwesenheiten="updateAnwesenheiten($event);"
      />
    </transition>
    <transition
      v-else-if="
        currentTab.code === 'set'
        && tabs.filter((o) => o.erlaubt === 'x|200|set').length > 0
      "
      name="custom-classes-transition"
      :enter-active-class="transitionIn"
      :leave-active-class="transitionOut"
    >
      <Einstellungen
        v-if="save.xtime"
        :prop_klassen="save.klassen"
        :prop_settings="save.settings"
        @saveSettings="tryGetOrSaveSettings($event);"
        @schuljahrAbgeschlossen="schuljahrDatenNeuLaden();"
        @server-erreichbar="serverErreichbar();"
      />
    </transition>
    <p v-else>
      Zugriff verweigert
    </p>
    <!-- CONTENT -->
    <viewTabsBottom v-if="tabs.length > 1" :tabs="tabs" />
  </div>
</template>

<script>
import 'animate.css';
import $ from 'jquery';
import ViewTabsTop from '@/components/ViewTabsTop.vue';
import ViewTabsBottom from '@/components/ViewTabsBottom.vue';
import { sichereApiFehlermeldung } from '@/utils/apiFehler';

import Kinderverwaltung from '@/components/Funktionen/200/200/Kinderverwaltung.vue';
import Elternverwaltung from '@/components/Funktionen/200/200/Elternverwaltung.vue';
import Statistik from '@/components/Funktionen/200/200/Statistik.vue';
import Einstellungen from '@/components/Funktionen/200/200/Einstellungen.vue';

export default ({
  name: 'Kinder',
  components: {
    ViewTabsTop,
    ViewTabsBottom,
    Kinderverwaltung,
    Elternverwaltung,
    Statistik,
    Einstellungen,
  },
  data: () => ({
    loading: false,
    offline: typeof navigator !== 'undefined' && navigator.onLine === false,
    syncProblem: '',
    anfrageGeneration: 0,
    save: {},
    anwesenheitenGeladen: false,
    anwesenheitenAngefordert: false,
    kindUpdated: false,
    doRender: false,
    tabs: [],
    mytabs: [
      {
        icon: 'mdi-human-child',
        title: 'Kinder',
        route: '/200',
        erlaubt: 'x|200|000|000',
      },
      {
        icon: 'mdi-human-male-female-child',
        title: 'Eltern',
        route: '/200-100',
        erlaubt: 'x|200|100',
      },
      {
        icon: 'mdi-chart-bar',
        title: 'Statistik',
        route: '/200-200',
        erlaubt: 'x|200|200',
      },
      {
        icon: 'mdi-tune',
        title: 'Einstellungen',
        route: '/200-set',
        erlaubt: 'x|200|set',
      },
    ],
    currentTab: {
      code: '',
      query: {},
    },
  }),
  computed: {
    transitionIn() {
      let result = '';
      if (this.$vuetify.breakpoint.mdAndDown) {
        result = 'animate__animated animate__fadeInLeft';
      }
      return result;
    },
    transitionOut() {
      let result = '';
      if (this.$vuetify.breakpoint.mdAndDown) {
        result = 'animate__animated animate__fadeOutLeft';
      }
      return result;
    },
  },
  methods: {
    f200Fehlerantwort(xhr) {
      if (xhr && xhr.responseJSON && typeof xhr.responseJSON === 'object') {
        return xhr.responseJSON;
      }
      if (!xhr || typeof xhr.responseText !== 'string') return {};
      const antwort = xhr.responseText.trim();
      if (!antwort || antwort[0] !== '{') return {};
      try {
        return JSON.parse(antwort);
      } catch {
        return {};
      }
    },
    f200ServerFehler(ergebnis, fallback) {
      const antwort = ergebnis && typeof ergebnis === 'object' ? ergebnis : {};
      const meldungen = [];
      const hauptmeldung = sichereApiFehlermeldung(antwort.message, '');
      if (hauptmeldung) meldungen.push(hauptmeldung);
      if (antwort.validationErrors && typeof antwort.validationErrors === 'object') {
        Object.values(antwort.validationErrors)
          .reduce((alle, wert) => alle.concat(Array.isArray(wert) ? wert : [wert]), [])
          .forEach((wert) => {
            const meldung = sichereApiFehlermeldung(String(wert || ''), '');
            if (meldung && !meldungen.includes(meldung)) meldungen.push(meldung);
          });
      }
      let text = meldungen.join(' ') || fallback;
      const fehlerId = typeof antwort.errorId === 'string' ? antwort.errorId.trim() : '';
      if (/^[a-z0-9._-]{1,80}$/i.test(fehlerId) && !text.includes(fehlerId)) {
        text += ` (Fehler-ID: ${fehlerId})`;
      }
      return text;
    },
    f200SpeicherfehlerMelden(text) {
      this.$store.commit('main/alert', {
        typ: 'error',
        text: `${text} Ihre Eingaben bleiben erhalten.`,
      }, { root: true });
    },
    schuljahrDatenNeuLaden() {
      localStorage.removeItem('f200');
      this.$set(this.save, 'anwesenheiten', []);
      this.$set(this.save, 'anwesenheitenMonate', {});
      this.anwesenheitenGeladen = false;
      this.anwesenheitenAngefordert = false;
      this.$store.commit('f200/setStateStore', { name: 'anwesenheiten', val: [] });
      this.$store.commit('f200/setStateStore', { name: 'anwesenheitenMonate', val: {} });
      this.tryGetOrSaveSettings();
    },
    async tryGetOrSaveSettings(dataToSave, ladeOverride) {
      // Nur die benötigten Datenbereiche anfordern (Performance): Standard-Load =
      // kinder+eltern (OHNE Anwesenheits-Dump), Status-Wechsel = nur kinder,
      // Statistik fordert 'anwesenheiten' explizit via ladeOverride an.
      let lade = ladeOverride || ['kinder', 'eltern'];
      if (!ladeOverride && dataToSave && dataToSave.dataToSave
        && dataToSave.dataToSave.type === 'anwesenheitsstatus') {
        lade = ['kinder'];
      }
      if (dataToSave) {
        // console.log(dataToSave);
        this.kindUpdated = false;
        if (!dataToSave.dataToSave.hideLoadingAnimation !== false) {
          this.$store.commit('main/switchIsSaving', true);
        }
      }
      this.loading = true;
      if (localStorage.getItem('f200')) {
        const help = JSON.parse(localStorage.getItem('f200'));
        if (help.save) {
          this.save = help.save;
          // this.loading = false;
        }
      }
      const anfrageGeneration = ++this.anfrageGeneration;
      $.ajax({
        url: `${process.env.VUE_APP_API_HOST}/200/200/?func=getSettings`,
        type: 'post',
        data: {
          code: this.$store.state.login.session.code,
          dataToSave: JSON.stringify(dataToSave),
          lade: JSON.stringify(lade),
        },
        success: (response) => {
          if (anfrageGeneration === this.anfrageGeneration) {
            // Eine verwertbare HTTP-Antwort bestaetigt die Verbindung auch dann,
            // wenn navigator.onLine noch einen veralteten Wert liefert.
            this.offline = false;
            this.syncProblem = '';
          }
          if (response && response.status === 'accessError') {
            this.$store.commit('login/backendErrorSession');
            return;
          }

          const geladen = response && Array.isArray(response.lade) ? response.lade : lade;
          const saveVollstaendig = response
            && response.status === 'success'
            && response.save
            && typeof response.save === 'object'
            && response.save.settings
            && Array.isArray(response.save.klassen)
            && Array.isArray(response.save.kinder)
            && (!geladen.includes('eltern') || Array.isArray(response.save.eltern))
            && (!geladen.includes('anwesenheiten') || (
              Array.isArray(response.save.anwesenheiten)
              && response.save.anwesenheitenMonate
              && typeof response.save.anwesenheitenMonate === 'object'
              && Array.isArray(response.save.anwesenheitenDokumente)
            ))
            && response.save.xtime;

          if (!saveVollstaendig) {
            const fehlermeldung = this.f200ServerFehler(
              response,
              dataToSave
                ? 'Der Server hat den Speichervorgang nicht bestätigt.'
                : 'Der Server hat keine vollständigen Kinderdaten geliefert.',
            );
            if (dataToSave) {
              this.f200SpeicherfehlerMelden(fehlermeldung);
            } else if (anfrageGeneration === this.anfrageGeneration) {
              this.syncProblem = fehlermeldung;
            }
            if (geladen.includes('anwesenheiten')) this.anwesenheitenAngefordert = false;
            return;
          }

          this.save.settings = response.save.settings;
          this.$store.commit('f200/setStateStore', { name: 'settings', val: response.save.settings });
          this.save.klassen = response.save.klassen;
          this.$store.commit('f200/setStateStore', { name: 'klassen', val: response.save.klassen });
          this.save.kinder = response.save.kinder;
          this.$store.commit('f200/setStateStore', { name: 'kinder', val: response.save.kinder });
          if (geladen.includes('eltern')) {
            this.save.eltern = response.save.eltern;
            this.$store.commit('f200/setStateStore', { name: 'eltern', val: response.save.eltern });
          }
          if (geladen.includes('anwesenheiten')) {
            // $set: diese Keys sind (weil erst lazy geladen) evtl. noch nicht
            // reaktiv auf save; sonst greifen spätere Aktualisierungen nicht in
            // einer bereits gemounteten Statistik-Komponente.
            this.$set(this.save, 'anwesenheiten', response.save.anwesenheiten);
            this.$store.commit('f200/setStateStore', { name: 'anwesenheiten', val: response.save.anwesenheiten });
            this.$set(this.save, 'anwesenheitenMonate', response.save.anwesenheitenMonate);
            this.$store.commit('f200/setStateStore', { name: 'anwesenheitenMonate', val: response.save.anwesenheitenMonate });
            this.$set(this.save, 'anwesenheitenDokumente', response.save.anwesenheitenDokumente);
            this.$store.commit('f200/setStateStore', { name: 'anwesenheitenDokumente', val: response.save.anwesenheitenDokumente });
            this.anwesenheitenGeladen = true;
          }
          this.save.xtime = response.save.xtime;
          this.$store.commit('f200/setStateStore', { name: 'v', val: response.save.xtime });
          if (this.save.settings.dataOffline) {
            let help = {
              save: {},
            };
            if (localStorage.getItem('f200')) {
              help = JSON.parse(localStorage.getItem('f200'));
            }
            help.save = this.save;
            localStorage.setItem('f200', JSON.stringify(help));
          } else {
            localStorage.removeItem('f200');
          }
          // Ein Bearbeitungsdialog darf erst nach der expliziten
          // Erfolgsbestaetigung samt vollstaendigem save geschlossen werden.
          if (dataToSave) {
            /* this.$store.commit('main/alert', {
              typ: 'success',
              text: 'Erfolgreich gespeichert',
            }, { root: true }); */
            if (dataToSave.dataToSave.type === 'anwesenheitsstatus') {
              /* console.log(response);
              console.log(
                this.save.kinder
                  .filter((o) => o.id === dataToSave.dataToSave.data.id_kind)[0],
              ); */
            }
            if (
              (dataToSave.dataToSave.data.kind && dataToSave.dataToSave.data.success === 'kindUpdated')
              || (dataToSave.dataToSave.data.eltern && dataToSave.dataToSave.data.success === 'kindUpdated')
            ) {
              this.kindUpdated = true;
            }
          }
        },
        timeout: 15000,
        error: (xhr, textStatus) => {
          const serverAntwort = this.f200Fehlerantwort(xhr);
          if (serverAntwort.status === 'accessError') {
            this.$store.commit('login/backendErrorSession');
            return;
          }
          // Anwesenheits-Load fehlgeschlagen -> Anforderung zurücknehmen, damit
          // ein späterer Tabwechsel es erneut versucht.
          if (lade.includes('anwesenheiten')) {
            this.anwesenheitenAngefordert = false;
          }
          if (anfrageGeneration === this.anfrageGeneration && textStatus !== 'abort') {
            const httpStatus = xhr ? Number(xhr.status) : 0;
            const serverHatGeantwortet = httpStatus > 0;
            const browserIstOffline = !serverHatGeantwortet
              && typeof navigator !== 'undefined'
              && navigator.onLine === false;
            this.offline = browserIstOffline;
            let fallback = 'Der Server konnte gerade nicht erreicht werden.';
            if (textStatus === 'timeout') {
              fallback = 'Der Server hat nicht innerhalb von 15 Sekunden geantwortet.';
            } else if (textStatus === 'parsererror') {
              fallback = 'Die Serverantwort konnte nicht verarbeitet werden.';
            } else if (httpStatus >= 500) {
              fallback = dataToSave
                ? 'Beim Speichern ist ein interner Serverfehler aufgetreten.'
                : 'Beim Laden ist ein interner Serverfehler aufgetreten.';
            } else if (httpStatus >= 400) {
              fallback = dataToSave
                ? 'Der Server hat den Speichervorgang abgelehnt.'
                : 'Der Server hat die Datenanforderung abgelehnt.';
            }
            const fehlermeldung = this.f200ServerFehler(serverAntwort, fallback);
            this.syncProblem = browserIstOffline ? '' : fehlermeldung;
            if (dataToSave) this.f200SpeicherfehlerMelden(fehlermeldung);
          }
        },
        complete: () => {
          this.loading = false;
          if (dataToSave) {
            if (!dataToSave.dataToSave.hideLoadingAnimation) {
              this.$store.commit('main/switchIsSaving', false);
            }
          }
        },
      });
    },
    updateAnwesenheiten(neu) {
      // $set, da die Keys evtl. noch nicht reaktiv auf save liegen -> sonst
      // bekäme die bereits gemountete Statistik-Komponente die Änderung (z.B.
      // eine frisch erstellte Auswertung im Archiv) nicht mit.
      if (neu.anwesenheiten) {
        this.$set(this.save, 'anwesenheiten', neu.anwesenheiten);
      }
      if (neu.anwesenheitenMonate) {
        this.$set(this.save, 'anwesenheitenMonate', neu.anwesenheitenMonate);
      }
      if (neu.anwesenheitenDokumente) {
        this.$set(this.save, 'anwesenheitenDokumente', neu.anwesenheitenDokumente);
      }
      if (this.save.settings.dataOffline) {
        let help = {
          save: {},
        };
        if (localStorage.getItem('f200')) {
          help = JSON.parse(localStorage.getItem('f200'));
        }
        help.save = this.save;
        localStorage.setItem('f200', JSON.stringify(help));
      } else {
        localStorage.removeItem('f200');
      }
    },
    handleOffline() {
      this.offline = true;
    },
    handleOnline() {
      const neuLaden = this.offline || Boolean(this.syncProblem);
      this.offline = false;
      if (neuLaden && !this.loading) this.tryGetOrSaveSettings();
    },
    handleFocus() {
      if ((this.offline || this.syncProblem) && !this.loading
        && (typeof navigator === 'undefined' || navigator.onLine !== false)) {
        this.tryGetOrSaveSettings();
      }
    },
    serverErreichbar() {
      const neuLaden = this.offline || Boolean(this.syncProblem);
      this.offline = false;
      if (neuLaden && !this.loading) this.tryGetOrSaveSettings();
    },
    setCurrentTab(route) {
      this.currentTab.code = route.path.replace(this.$router.history.current.path.substring(0, 4), '').replace('-', '');
      this.currentTab.query = route.query;
      this.doRender = true;
      // Statistik-Tab: den teuren Anwesenheits-Dump erst hier (einmalig) nachladen.
      // anwesenheitenAngefordert verhindert einen zweiten Request, wenn er beim
      // direkten Landen auf /200-200 bereits im ersten Load enthalten ist.
      if (this.currentTab.code === '200' && !this.anwesenheitenGeladen && !this.anwesenheitenAngefordert) {
        this.anwesenheitenAngefordert = true;
        this.tryGetOrSaveSettings(undefined, ['anwesenheiten']);
      }
      // Elternkonto-Deeplinks werden in Elternverwaltung anhand der ID geöffnet.
      // Der Dialog ist dort unabhängig von Suche und Tabellenpaginierung gerendert.
    },
  },
  created() {
    window.addEventListener('offline', this.handleOffline);
    window.addEventListener('online', this.handleOnline);
    window.addEventListener('focus', this.handleFocus);
    // Landet man DIREKT auf der Statistik (/200-200), die Anwesenheiten (inkl.
    // Archiv-Dokumente) gleich im ersten Request mitladen. Sonst läuft ein
    // zweiter Request dagegen und die bereits gemountete Statistik-Komponente
    // sieht die nachgelieferten Dokumente nicht mehr (leeres Archiv).
    const startCode = this.$router.history.current.path
      .replace(this.$router.history.current.path.substring(0, 4), '').replace('-', '');
    if (startCode === '200') {
      this.anwesenheitenAngefordert = true;
      this.tryGetOrSaveSettings(undefined, ['kinder', 'eltern', 'anwesenheiten']);
    } else {
      this.tryGetOrSaveSettings();
    }
    if (this.$store.state.main.save.mainmenu_links
      .some((e) => e.route === this.$router.history.current.path.substring(0, 4))) {
      // Wenn Zugriff auf diese View erlaubt
      // erlaube das Rendern
      this.setCurrentTab(this.$router.history.current);
    } else {
      // Wenn Zugriff auf diese View NICHT erlaubt
      // Leite zur ersten erlaubten Seite um
      this.$router.push({ path: this.$store.state.main.save.mainmenu_links[0].route });
      localStorage.removeItem('f200');
      localStorage.removeItem('f200_filterClass');
      localStorage.removeItem('f200_timeAnm');
      window.location.reload();
    }
    // Tabs erstellen:
    this.mytabs.forEach((tab) => {
      if (
        this.$store.state.main.save.user.rechte.find((element) => {
          let bool = false;
          if (element.includes(tab.erlaubt)) {
            bool = true;
          }
          return bool;
        })
      ) {
        this.tabs.push(tab);
      }
    });
    // Wenn der aktuelle Tabs nicht erlaubt ist, zum ersten erlaubten Tab navigieren:
    if (
      this.tabs.filter((o) => o.route === this.$router.history.current.path).length <= 0
      && this.tabs.length > 0
    ) {
      this.$router.push({ path: this.tabs[0].route });
    }
  },
  beforeRouteUpdate(to, from, next) {
    // Beim Wechsel zwischen den Tabs dieser Seite NICHT den gesamten Datensatz
    // neu laden — er ist bereits geladen (created()), und Speichern/Edits laden
    // ohnehin selbst nach. Nur laden, falls die Daten noch fehlen (z.B. Deep-Link
    // direkt auf einen Tab, bevor created() fertig ist).
    if (to.path.substring(1, 4) === '200' && !this.save.xtime) {
      this.tryGetOrSaveSettings();
    }
    this.setCurrentTab(to);
    next();
  },
  beforeDestroy() {
    window.removeEventListener('offline', this.handleOffline);
    window.removeEventListener('online', this.handleOnline);
    window.removeEventListener('focus', this.handleFocus);
  },
});
</script>

<style>
</style>
